'use client';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Contentsexmobile = () => {
  return (
    <section className="w-full mb-[32px]">
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[18px] mt-[32px] mb-[16px] font-medium text-black/85">公司简介</h2>
        <div className="px-[20px]">
          <DynamicImage
            src="https://osscdn.weiyouzhihui.com/editorVideo/1736478021261/Frame%201312321181%402x.png"
            className="w-full h-[222px]"
          ></DynamicImage>
          <div className="px-[20px]">
            <p
              className="w-full h-[240px] text-[rgba(0,0,0,0.65)] text-[13px] rounded-b-[15px] text-left leading-[23px] p-[15px]"
              style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)' }}
            >
              微友智汇SCRM是深圳市朱雀软件科技有限公司旗下的服务营销一体化平台，微友智汇SCRM以客户为核心，通过社交媒体平台连接企业与客户。通过整合多渠道客户数据，实现自动化管理流程，促进企业在社交媒体平台上与客户高效互动，同时为企业提供个性化服务与精准营销，帮助企业实现全渠道客户服务，精细化客户关系管理，优化客户体验，帮助机构找到全链路可落地的闭环增长策略与数字化解决方案...
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Contentsexmobile;
